import { render } from "./SportHeader.vue?vue&type=template&id=1a4da168&scoped=true"
import script from "./SportHeader.vue?vue&type=script&lang=js"
export * from "./SportHeader.vue?vue&type=script&lang=js"

import "./SportHeader.vue?vue&type=style&index=0&id=1a4da168&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4da168"]])

export default __exports__